/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGATourSaveModelFiltersInput = {|
  name: string,
  modelId: string,
  clientMutationId?: ?string,
|};
export type PGAModelBuilderPageSaveFiltersMutationVariables = {|
  input: PGATourSaveModelFiltersInput
|};
export type PGAModelBuilderPageSaveFiltersMutationResponse = {|
  +pgaTourSaveModelFilters: ?{|
    +success: ?boolean
  |}
|};
export type PGAModelBuilderPageSaveFiltersMutation = {|
  variables: PGAModelBuilderPageSaveFiltersMutationVariables,
  response: PGAModelBuilderPageSaveFiltersMutationResponse,
|};
*/


/*
mutation PGAModelBuilderPageSaveFiltersMutation(
  $input: PGATourSaveModelFiltersInput!
) {
  pgaTourSaveModelFilters(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PGATourSaveModelFiltersPayload",
    "kind": "LinkedField",
    "name": "pgaTourSaveModelFilters",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderPageSaveFiltersMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderPageSaveFiltersMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a3688e1ef857e330964a6a5438ebb0ae",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderPageSaveFiltersMutation",
    "operationKind": "mutation",
    "text": "mutation PGAModelBuilderPageSaveFiltersMutation(\n  $input: PGATourSaveModelFiltersInput!\n) {\n  pgaTourSaveModelFilters(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3e1712808da38e5fe8095e205008185a';

module.exports = node;
